import React, { useContext } from "react";
import { APIContext } from "../../modules/context/ContextProvider";
import LoadingScreen from "../../modules/core/components/pop_up/progress_bar/LoadingScreen";

export interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAuth?: boolean;
  requiredUserType?: string;
  signInMessage?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const context = useContext(APIContext);

  if (context?.isLoading) {
    return <LoadingScreen />;
  }

  return children;
};

export default ProtectedRoute;
